
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMoreGoogle as ObiMoreGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-more-google.js';
 
 
 

 
 export const ObiMoreGoogle = createComponent({
   react: React,
   tagName: 'obi-more-google',
   elementClass: ObiMoreGoogleElement,
   events: {
     
   }
  });
 
 